import { observer } from 'mobx-react-lite'
import type {
  OutlineViewModel,
  StepViewModel,
} from '@/features/jobs/drafting/OutlineViewModel'
import {
  Outline,
  OutlineItem,
} from '@/features/jobs/drafting/components/JobCreation/Outline'

export interface OutlineContainerProps {
  vm: OutlineViewModel
  title: string
}

export const OutlineContainer = observer(function OutlineContainer({
  vm,
  title,
}: OutlineContainerProps) {
  return (
    <Outline title={title}>
      {vm.stepAccessors.map((stepAccessor) => (
        <OutlineItemContainer
          key={stepAccessor.step.stepId}
          vm={stepAccessor.step}
          pulse={stepAccessor.step === vm.firstIncompleteStep}
        />
      ))}
    </Outline>
  )
})

export interface OutlineItemContainerProps {
  vm: StepViewModel
  pulse: boolean
}

export const OutlineItemContainer = observer(function OutlineItemContainer({
  vm,
  pulse,
}: OutlineItemContainerProps) {
  return (
    <OutlineItem
      stepId={vm.stepId}
      title={vm.outlineDisplay.title}
      value={vm.outlineDisplay.value}
      shortValue={vm.outlineDisplay.shortValue}
      visual={vm.outlineDisplay.visual}
      isActive={vm.isActive}
      pulse={pulse}
      onPress={vm.becomeActive}
    />
  )
})
